import React from "react"
import { has } from "lodash"

import MyReview from "./Reviews/MyReview"
import Reviews from "./Reviews/Reviews"
import Error from "./../../general/Error"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"


//column for game reviews
class ReviewColumn extends React.PureComponent{
    constructor(){
        super();
        this.state = {
            isLoading: true,
            reviews: null,
            reviewsError: "",
            myReview: null,
            myReviewError: ""
        }
    }
    componentDidMount(){
        fetch(`/api/store/project/${this.props.data.id}/review/list`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({reviews: data.values})
        })
        .catch(data => this.setState({reviewsError: `Server: ${data.error}`, isLoading: false}))
        fetch(`/api/store/project/${this.props.data.id}/review/me`)
        .then(res => res.json())
        .then(data => {
            if (has(data, "error")){ throw data }
            this.setState({
                myReview: data.result, 
                isLoading: false
            })
        })
        .catch(data => this.setState({myReviewError: `Server: ${data.error}`, isLoading: false}))
    }
    updateMyReview = (review) =>{
        this.setState({myReview: review, upvote: review.upvote})
    }
    render(){
        const { data } = this.props
        const { isLoading, reviews, myReview } = this.state
        if (isLoading) return (
            <h3 className="loading"><FontAwesomeIcon icon={faSpinner} spin /></h3>
        )
        return(
            <div className="reviewColumn">
                {this.state.myReviewError === ""
                ? <MyReview data={data} myReview={myReview} updateMyReview={this.updateMyReview}/>
                : <Error error={this.state.myReviewError} />}

                {this.state.reviewsError === ""
                ? (Array.isArray(reviews) && reviews.length === 0)
                    ||<>
                        <hr />
                        <Reviews reviews={this.state.reviews}/>
                    </>
                : <Error error={this.state.myReviewError} />}
            </div>
        )
    }
}

export default ReviewColumn